import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { useAnalytics } from './hooks/useAnalytics';
function AppContent() {
  const location = useLocation();
  const {
    trackPageView
  } = useAnalytics();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location, trackPageView]);
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/contact" element={<ContactPage data-id="element-7" />} data-id="element-6" />
        </Routes>
      </main>
      <Footer data-id="element-8" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-9">
      <AppContent data-id="element-10" />
    </BrowserRouter>;
}